import React from 'react';
import PropTypes from 'prop-types';
import { ModalContainer } from '@containers/layout';
import { Box, Button } from '@components/common';
import DialogBox from '@components/DialogBox';
import HSvsDCDiff from './HSvsDCDiff';

function HSvsDCModal(props) {
  const { show, dismiss } = props;
  return (
    <DialogBox
      show={show}
      onClickOutside={dismiss}
      flexDirection="column"
      justifyContent="flex-start"
      pt={[7, 8]}
      pb={5}
    >
      <ModalContainer>
        <Box display="flex" flexDirection="column" my={4}>
          <HSvsDCDiff />
          <Button width="100%" mt={20} onClick={dismiss}>
            Done
          </Button>
        </Box>
      </ModalContainer>
    </DialogBox>
  );
}

HSvsDCModal.propTypes = {
  show: PropTypes.bool,
  dismiss: PropTypes.func
};

export default HSvsDCModal;
